<a
  class="map-card"
  *ngIf="object"
  [href]="detailPageUrl"
  (click)="onLinkClick($event)"
>
  <span class="map-card__visual">
    <span class="map-card__image" [style.backgroundImage]="firstImageUrl">
    </span>
  </span>

  <span class="map-card__main">
    <span class="map-card__location">
      <lib-location-display [location]="object.location"></lib-location-display>
    </span>

    <span class="map-card__chips">
      <span class="map-card__chip" *ngIf="object.floorSpace">
        <lib-chip> {{ object.floorSpace }} m<sup>2</sup> </lib-chip>
      </span>

      <span class="map-card__chip" *ngIf="object.roomCount">
        <lib-chip>
          {{ object.roomCount }} {{ 'filters.roomCount.label' | i18n }}
        </lib-chip>
      </span>

      <span class="map-card__chip">
        <lib-chip>
          <ng-container *ngIf="price; else priceOnRequest">
            <span [innerHTML]="price"></span>
          </ng-container>
          <ng-template #priceOnRequest>
            {{ 'realEstateObject.priceOnRequest' | i18n }}
          </ng-template>
        </lib-chip>
      </span>
    </span>
  </span>
</a>
